import React from 'react'
import {type AudioContextT} from '@freckle/student/ts/common/logic/web-audio'

export const AudioContext: React.Context<AudioContextT | null | undefined> = React.createContext<
  AudioContextT | null | undefined
>(null)

AudioContext.displayName = 'AudioContext'
